export const strings = {
  home_title: 'Ev',
  write_here: 'Buraya yazın...',
  about: 'Hakkımda',
  about_connections:
    'Bağlantılarınızın kişiliğiniz hakkında daha fazla bilgi sahibi olmasını sağlayın',
  add: 'Eklemek',
  education: 'Eğitim',
  education_details:
    'Bağlantılarınızın nerede eğitim aldığınızı bilmesini sağlayın',
  experience: 'Deneyim',
  experience_details:
    'Bağlantılarınızın ne yaptığınız hakkında bilgi sahibi olmasını sağlayın',
  interest: 'Çıkar',
  interest_details:
    'İlgili bilgileri göstermemize yardımcı olmak için bize ilgi alanlarınızdan bahsedin',
  medical_audit: 'Tıbbi Denetimi günlüğe kaydetmeniz mi gerekiyor?',
  new_log: 'Yeni Günlük Ekle',
  all_log: 'Tüm Günlükleri Gör',
  profile: 'Profil',
  boost_profile: 'Profilinizi güçlendirin',
  sub_speciality: 'Alt uzmanlık',
  add_speciality:
    'Size ilgili bilgileri göstermemize yardımcı olmak için alt uzmanlık alanınızı ekleyin',
  profile_picture: 'Profil Resmi',
  set_profile:
    'Profil resminizi şimdi ayarlayın ve daha fazla bağlantı isteği alın',
  upload: 'Karşıya yükleme',
  view_profile: 'Profil Görünümleri',
  post: 'Mesaj',
  follower: 'Takipçi -leri',
  poll_uuid: 'Anket',
  complete: 'Tamamlamak',
  errors: {
    biography: 'Hakkımda gerekli',
    biography_max_length: 'Hakkımda 200 karakterden fazla olamaz',
  },
};
